import { render, staticRenderFns } from "./vendor-regulator-select.vue?vue&type=template&id=aed12a40&"
import script from "./vendor-regulator-select.vue?vue&type=script&lang=js&"
export * from "./vendor-regulator-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports